export default "{\n    \"label\": \"Equipo\",\n    \"placeholder\": \"Seleccione equipo\"\n}"